// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-7rHnu","title":"title-2rc-l","icon":"icon-3twmJ","content":"content-3VNh7","condition":"condition-2kyL8"};